import React from 'react'
import banner from '../Images/Banner/RFID_Antenna.jpg';
import {ImHome} from 'react-icons/im';
import Antenna1 from '../Images/Products/AN480.png';
import Antenna from '../Images/Products/AN440.png';
import Antenna2 from '../Images/Products/RS900_1.png';
import Antenna3 from '../Images/Products/RS1200_2.png';
import Footer from '../Footer';
import AN440 from '../Documents/AN440-Specification.pdf';
import AN480 from '../Documents/AN480-Specification.pdf';
import RS900 from '../Documents/RS900-Specification.pdf';
import RS1200 from '../Documents/ART7000-Specification.pdf';

import ScrollButton from '../Home/Scrollbutton';
const Rfidantenna = () => {
  window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
  return (
    <>
    <div className='container'>
      <div className="mb-0 bg-light">
          <img src ={banner} alt="RFID-slide" className='img-fluid'/> 
          <div className='d-flex p-1'>
            <ImHome className='m-1'/>
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb">
                <li className="breadcrumb-item ms-1"> <a href="/">Home</a></li>
                <li className="breadcrumb-item ms-1"> <a href="/product">Products</a></li>
                <li className="breadcrumb-item active" aria-current="page">RFID Readers</li>
              </ul>
            </nav>
          </div>
      
      </div>
    </div>
    <div className='container'>
      <div className='Prod-head-title fw-bold mt-5'><h1>TYPES OF RFID ANTENNAS</h1>
        <h5 className='mt-4'>Searching for The Right RFID Reader</h5>
      </div>
    </div>
      <div className='container'>
        <div className="row row-cols-1 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 g-3">
            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">AN480 Antenna</h5>
                  <img src={Antenna} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                  
                    <div className='download-cat'>
                      <a href={AN480} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">AN440 Antenna</h5>
                  <img src={Antenna1} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                  
                    <div className='download-cat'>
                      <a href={AN440} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">Ultra Rugged RS900 UHF Antenna</h5>
                  <img src={Antenna2} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                  
                    <div className='download-cat'>
                      <a href={RS900} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">Ultra Rugged RS1200 UHF Antenna</h5>
                  <img src={Antenna3} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                  
                    <div className='download-cat'>
                      <a href={RS1200} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          
        </div> 
      </div> 
        <br/>
        <br/>
        <br/>
        <div className='container'>
      <div className='why-bg img-fluid'>
        <h1 className=' container d-inline-block text-center text-white fw-bold pt-5'>WHY CHOOSE RSPM RFID ANTENNAS</h1>
        <div className=" row row-cols-1 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 m-5 g-5 ">
          <div className='col'>
            <div className='RFID-card'>
              <div className='p-4'>
                <div className='RFID-num fw-bold '>01</div>
                <div className='RFID-Content mt-5'>
                 <h3 className='mt-3 fw-bold'>Globally applying</h3>
                 <p className='mt-3'>ISO18000-6B/6C and EPC Global UHF Class 1 Gen 2.</p>
                </div>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='RFID-card mt-5'>
              <div className='p-4'>
                <div className='RFID-num fw-bold '>02</div>
                <div className='RFID-Content mt-5'>
                 <h3 className='mt-3 fw-bold'>Excellent performance</h3>
                 <p className='mt-3'>High speed and accurancy in a long reading distance. Remarkable multiple reading and stable reading performance in variety of surrounding.</p>
                 
                </div>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='RFID-card'>
              <div className='p-4'>
                <div className='RFID-num fw-bold '>03</div>
                <div className='RFID-Content mt-5'>
                 <h3 className='mt-3 fw-bold'>Rugged and durable</h3>
                 <p className='mt-3'>Premium design and workmanship can used in harsh environment.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
        
      <ScrollButton/>
      <Footer/>
    </>
  )
}

export default Rfidantenna